import { render, staticRenderFns } from "./PJCustomerCompliance.vue?vue&type=template&id=54d3d3d5"
import script from "./PJCustomerCompliance.vue?vue&type=script&lang=js"
export * from "./PJCustomerCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports